export const BASE_API_URL = process.env.REACT_APP_API_KEY
// export const BASE_API_URL="http://192.168.4.75:8000";
export const WEB_DOMAIN = process.env.REACT_APP_WEB_DOMAIN;

export const URL = {
  "LOGIN": BASE_API_URL + '/login',
  "FETCH_RECORDS": BASE_API_URL + '/get_records',
  "FETCH_PROSTATE_CANCER_RECORDS": BASE_API_URL + '/get_prostate_records',
  "FETCH_MENTAL_HEALTH_RECORDS": BASE_API_URL + '/get_records',
  "ADD_INDIVIDUAL_RECORDS": BASE_API_URL + '/submit_individual_records',
  "ADD_MULTIPLE_RECORDS": BASE_API_URL + '/submit_bulk_record',

  "ADD_INDIVIDUAL_RECORDS_V2": BASE_API_URL + '/submit_individual_records_v2',
  "ADD_MULTIPLE_RECORDS_V2": BASE_API_URL + '/submit_bulk_record_v2',

  "ADD_PROSTATE_INDIVIDUAL_RECORDS": BASE_API_URL + '/submit_prostate_records',
  "ADD_PROSTATE_BULK_RECORDS": BASE_API_URL + '/submit_prostate_bulk_records',

  "DELETE_RECORDS": BASE_API_URL + '/delete_records',
  "FETCH_USER_LIST": BASE_API_URL + '/user_list',
  "FETCH_ORG_LIST": BASE_API_URL + '/org_list',
  "FETCH_ROLE_LIST": BASE_API_URL + '/role_list',
  "ADD_USER": BASE_API_URL + '/add_user',
  "UPDATE_USER": BASE_API_URL + '/update_user',
  "ADD_ORGANIZATION": BASE_API_URL + '/addOrg',
  "FETCH_COUNTRIES": BASE_API_URL + '/get_countries',
  "FETCH_STATES": BASE_API_URL + '/get_states',
  "FETCH_CITIES": BASE_API_URL + '/get_cities',
  "DELETE_USER": BASE_API_URL + '/delete_user',
  "DELETE_ORGANIZATION": BASE_API_URL + '/delete_organization',
  "FETCH_RANGE_FIELD_MAX_MIN_VALUES": BASE_API_URL + '/get_maxmin_value',
  "UPDATE_ORGANIZATION": BASE_API_URL + '/edit_organization',
}